import React, { useState } from 'react'
import { Formik } from 'formik'
import cn from 'classnames'

import BgRefeicao from 'assets/img/card-backgrounds/bg_refeicao.jpg'
import Refeicao from 'assets/img/cards/refeicao.png'

import ProductCard from '../ProductCard'
import Button from '../../Button'

import StringFormat from 'utils/StringFormat'

import { TagPushCarousel } from 'analytics/carousel'

const REFEICAO = 'refeicao'
const MealProductCard = (props) => {
    const initialValues = {
        quantity: props.cart ? props.cart.qnt.toString() : '',
        value: props.cart ? props.cart.value.toString() : '0',
        type: 'monthly'
    }

    const [, setErrors] = useState({})

    return (
        <ProductCard
            {...props}
            id="Meal"
            background={BgRefeicao}
            card={Refeicao}
            name="Refeição"
            url={REFEICAO}
            description="Pagamento de suas refeições em restaurantes, bares, fast foods, lanchonetes e similares."
        >
            {(backFlip, addProduct, minValue, maxValue, id, bank) => (
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validate={(values) => {
                        let errors = {}

                        if (
                            !values.quantity.replace(/\D/g, '') ||
                            +values.quantity < 1
                        ) {
                            let msgError =
                                'Informe a quantidade desejada de cartões.'
                            errors['quantity'] = msgError
                            TagPushCarousel.interactionProductField(
                                REFEICAO,
                                msgError,
                                bank,
                                'quantos cartoes'
                            )
                        }

                        const value = parseFloat(
                            StringFormat.removeMaskCurrency(
                                StringFormat.convertToMonetary(values.value, 6)
                            )
                        )

                        const realMinValue =
                            values.type === 'monthly'
                                ? minValue
                                : Math.floor((minValue / 22) * 100) / 100

                        const realMaxValue =
                            values.type === 'monthly'
                                ? maxValue
                                : Math.floor((maxValue / 22) * 100) / 100

                        const realType =
                            values.type === 'monthly' ? 'mensais' : 'diários'
                        const min = StringFormat.convertToMonetary(
                            realMinValue.toFixed(2)
                        )
                        const max = StringFormat.convertToMonetary(
                            realMaxValue.toFixed(2)
                        )

                        if (
                            (value < parseFloat(realMinValue.toFixed(2)) ||
                                value > parseFloat(realMaxValue.toFixed(2))) &&
                            value > 0
                        ) {
                            errors['value'] =
                                `Insira um valor entre <strong>${min}</strong> e <strong>${max}</strong> ${realType}.`
                        }

                        setErrors(errors)

                        return errors
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        const value = parseFloat(
                            StringFormat.removeMaskCurrency(
                                StringFormat.convertToMonetary(values.value, 6)
                            )
                        )

                        const newValues =
                            values.type === 'daily'
                                ? {
                                      ...values,
                                      value: (value * 22).toFixed(2),
                                      type: 'monthly'
                                  }
                                : {
                                      ...values,
                                      value: value.toFixed(2),
                                      type: 'monthly'
                                  }

                        addProduct(newValues, props)

                        setSubmitting(false)
                        resetForm(newValues)
                        backFlip()
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        resetForm
                    }) => (
                        <form
                            autoComplete="off"
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <div className="inputs">
                                <div className="field">
                                    <label htmlFor={`cardQuantity${id}`}>
                                        Quantos cartões?
                                    </label>
                                    <div className="control">
                                        <input
                                            id={`cardQuantity${id}`}
                                            maxLength="4"
                                            onChange={(e) => {
                                                e.target.value =
                                                    StringFormat.maxLength(
                                                        StringFormat.justNumber(
                                                            e.target.value
                                                        ),
                                                        4
                                                    )
                                                handleChange(e)
                                            }}
                                            onBlur={(e) => {
                                                handleBlur(e)
                                                if (!errors.quantity) {
                                                    TagPushCarousel.interactionProductField(
                                                        REFEICAO,
                                                        null,
                                                        bank,
                                                        'quantos cartoes'
                                                    )
                                                }
                                            }}
                                            className={cn('input', {
                                                'input--error':
                                                    touched.quantity &&
                                                    errors.quantity
                                            })}
                                            name="quantity"
                                            type="tel"
                                            value={StringFormat.justNumber(
                                                values.quantity
                                            )}
                                        />
                                    </div>
                                    <span className="error-text">
                                        {errors.quantity && touched.quantity
                                            ? errors.quantity
                                            : null}
                                    </span>
                                </div>
                                <div className="field">
                                    <label htmlFor={`cardValue${id}`}>
                                        Qual valor (R$) por cartão?
                                    </label>
                                    <p className="control control-combine">
                                        <input
                                            id={`cardValue${id}`}
                                            maxLength="10"
                                            onChange={(e) => {
                                                e.target.value =
                                                    StringFormat.maxLength(
                                                        StringFormat.justNumber(
                                                            e.target.value
                                                        ),
                                                        6
                                                    )
                                                handleChange(e)
                                            }}
                                            onBlur={(e) => {
                                                handleBlur(e)
                                                if (!errors.value) {
                                                    TagPushCarousel.interactionProductField(
                                                        REFEICAO,
                                                        null,
                                                        bank,
                                                        'qual valor mensal'
                                                    )
                                                } else {
                                                    let msgError =
                                                        errors.value.replaceAll(
                                                            'strong',
                                                            ''
                                                        )
                                                    TagPushCarousel.interactionProductField(
                                                        REFEICAO,
                                                        msgError,
                                                        bank,
                                                        'qual valor mensal'
                                                    )
                                                }
                                            }}
                                            className={cn('input', {
                                                'input--error':
                                                    touched.value &&
                                                    errors.value
                                            })}
                                            name="value"
                                            type="tel"
                                            value={StringFormat.convertToMonetary(
                                                values.value,
                                                6
                                            )}
                                        />
                                        <select
                                            id={`valueType${id}`}
                                            onChange={handleChange}
                                            onBlur={(e) => {
                                                handleBlur(e)
                                                const selectedOption =
                                                    e.target.options[
                                                        e.target.selectedIndex
                                                    ]
                                                const label =
                                                    selectedOption.text
                                                TagPushCarousel.interactionProductDropdown(
                                                    bank,
                                                    label,
                                                    REFEICAO
                                                )
                                            }}
                                            name="type"
                                            value={values.type}
                                        >
                                            <option value="monthly">
                                                Mensal
                                            </option>
                                            <option value="daily">
                                                Diário
                                            </option>
                                        </select>
                                    </p>
                                    <span
                                        className="error-text"
                                        dangerouslySetInnerHTML={
                                            errors.value && touched.value
                                                ? {
                                                      __html: errors.value
                                                  }
                                                : null
                                        }
                                    />
                                </div>
                            </div>
                            <div className="actions">
                                <Button
                                    id={`seeCart${id}`}
                                    type="submit"
                                    kind={cn('add', {
                                        'button--add--disabled':
                                            !(
                                                values.value && values.quantity
                                            ) ||
                                            errors.value ||
                                            errors.quantity
                                    })}
                                >
                                    {props.purchased
                                        ? 'Atualizar cesta'
                                        : 'Ver quanto custa'}
                                </Button>
                                <button
                                    id={`backFlip${id}`}
                                    onClick={() => {
                                        resetForm(initialValues)
                                        backFlip()
                                    }}
                                    type="button"
                                    className="product-card__button product-card__button--close"
                                >
                                    Fechar
                                </button>
                            </div>
                        </form>
                    )}
                </Formik>
            )}
        </ProductCard>
    )
}

export default MealProductCard
